import { useContext, useEffect, useState } from "react";
import { Card, Spinner } from "reactstrap";
import styled from "styled-components";
import { BASE_URL } from "utilFunctions/Constants/urlConstants";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import "./studentLop.css";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import NoDataFoundWeaknessIcon from "Assets/Icons/NoDataFoundWeaknessIcon";
import { ToastContextDispatch } from "Context/CommonContext";
const ReasoningDiv = styled<any>("div")`
  border-radius: 4px;
  border: 0.5px solid var(--Grey-50, #afafaf);
  padding: 16px;
  margin-top: 16px;
`;
const IndexSpan = styled<any>("span")`
  color: ${(props: any) => (props.isWeak ? "#E7685A" : "#05945B")};
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px; /* 133.333% */
`;
const NameSpan = styled<any>("span")`
  color: #000;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  padding-left: 12px;
`;
const ReasoningHeaderDiv = styled<any>("div")`
  color: ${(props: any) =>
    props.isSelected ? (props.isWeak ? "#E7685A" : "#05945B") : "#AFAFAF"};
  border-bottom: ${(props: any) =>
    props.isSelected
      ? props.isWeak
        ? " 2px solid var(--Red-40, #E7685A)"
        : "2px solid var(--Green-50, #05945B)"
      : "none"};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  width: 42%;
  margin: auto;
  padding: 8px 12px;
  text-align: center;
  cursor: pointer;
`;
const StudentWeaknesStrengthComponent = ({ selectedStudent }: any) => {
  const { screen }: any = useWindowSize();
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const [reasoning, setReasoning] = useState<string>("reasonsofWeakness");
  const [reasonsWeaknessNStrengthData, setReasonsWeaknessNStrengthData] =
    useState<any>(null);
  const { makeRequest: GetLopReasonsForPeriod, loading } = useGetApi(
    (data: any) => {
      if (data && data["data"]) {
        setReasonsWeaknessNStrengthData(data["data"]);
      } else {
        setReasonsWeaknessNStrengthData(null);
      }
    },
    (error: any) => {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: error?.message,
      });
      setReasonsWeaknessNStrengthData(null);
    }
  );
  useEffect(() => {
    if (selectedStudent?.psid && selectedStudent.stream) {
      const url =
        BASE_URL +
        "lop/getLopReasonsForPeriod?" +
        `psid=${selectedStudent.psid}&stream=${selectedStudent.stream}`;
      GetLopReasonsForPeriod(url);
    }
  }, [selectedStudent]);
  const returnReasonListing = (
    name: string,
    index: number,
    isWeak: boolean
  ) => {
    return (
      <ReasoningDiv>
        <IndexSpan isWeak={isWeak}>{index}.</IndexSpan>
        <NameSpan>{name}</NameSpan>
      </ReasoningDiv>
    );
  };
  const reasoningSetHandler = () => {
    setReasoning(
      reasoning == "reasonsofWeakness"
        ? "reasonsofStrength"
        : "reasonsofWeakness"
    );
  };
  const returnReasoningCard = (isWeak: boolean, reasoning: string) => {
    return (
      <Card className={isWeak ? "w-100 mr-4" : "w-100"}>
        <div className="mainHeaderDivCSS">
          <ReasoningHeaderDiv isWeak={isWeak} isSelected={true}>
            {isWeak ? "☹️ Weakness" : "  🙂 Strength"}
          </ReasoningHeaderDiv>
        </div>
        <div className="mainListingDivCSS">
          {reasonsWeaknessNStrengthData[reasoning].map(
            (ele: any, index: number) =>
              returnReasonListing(ele, index + 1, isWeak)
          )}
        </div>
      </Card>
    );
  };
  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center w-100 p-3">
          <Spinner color="info"></Spinner>
        </div>
      ) : (
        <>
          {reasonsWeaknessNStrengthData != null ? (
            <div className="d-flex flex-row">
              {["xxl", "xl", "lg"].includes(screen) ? (
                <>
                  {returnReasoningCard(true, "reasonsofWeakness")}
                  {returnReasoningCard(false, "reasonsofStrength")}
                </>
              ) : (
                <Card className="w-100">
                  <div className="mainHeaderDivCSS">
                    <ReasoningHeaderDiv
                      isWeak={true}
                      onClick={reasoningSetHandler}
                      isSelected={
                        reasoning == "reasonsofWeakness" ? true : false
                      }
                    >
                      ☹️ Weakness
                    </ReasoningHeaderDiv>
                    <ReasoningHeaderDiv
                      isWeak={false}
                      onClick={reasoningSetHandler}
                      isSelected={
                        reasoning == "reasonsofStrength" ? true : false
                      }
                    >
                      🙂 Strength
                    </ReasoningHeaderDiv>
                  </div>
                  <div className="mainListingDivCSS">
                    {reasonsWeaknessNStrengthData[reasoning].map(
                      (ele: any, index: number) =>
                        returnReasonListing(
                          ele,
                          index + 1,
                          reasoning == "reasonsofWeakness" ? true : false
                        )
                    )}
                  </div>
                </Card>
              )}
            </div>
          ) : (
            <Card className="p-4">
              <NoResultFoundSearch
                primaryMessage="Student data not available."
                secondaryMessage={
                  "Student's strengths and weaknesses prediction data is not yet synchronized in the system; we're on it to provide you with comprehensive insights."
                }
              >
                <NoDataFoundWeaknessIcon />
              </NoResultFoundSearch>
            </Card>
          )}
        </>
      )}
    </>
  );
};
export default StudentWeaknesStrengthComponent;
